import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/de/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__en-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const QAPageJsonld = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  breadcrumb: 'Lemonade.com > Lemonade FAQ',
  name: 'Lemonade FAQ',
  image:
    'https://www.lemonade.com/assets/lemonade-share-image-ad9d7846f31685bfb4af89f018e4dd5d460f4e73768a8fd500bfc1f069ff853a.png',
  description:
    'FAQs on Lemonade Insurance, a property and casualty insurance company offering policies to renters and homeowners.',
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-DE'].layout },
  seo: {
    title: 'Contents & Personal Liability Insurance FAQ | Lemonade',
    metaTitle: 'Contents & Personal Liability Insurance FAQ | Lemonade',
    description:
      "Insurance can be confusing, but it doesn't have to be!! Here are some of Lemonade's top FAQs - from what renters insurance is, You'll also learn a bit more about extra coverage and Lemonade's business model.",
    jsonld: [QAPageJsonld],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
